import get from 'lodash/get'

export default (fields, localeId) => ({
  ...fields,
  previousWorkAsAssessor: get(fields, 'previousWorkAsAssessor') === 'yes',
  helpers: undefined,
  passwordAgain: undefined,
  emailAgain: undefined,
  addressCountryId: undefined,
  localeId: fields.localeId || localeId,
  terms: get(fields, 'helpers.terms'),
  agreementTermsAndConditions: get(fields, 'helpers.terms'),
  agreementCodeOfConduct: get(fields, 'helpers.agreementCodeOfConduct') ? true : false,
  agreementRoleResponsibility: get(fields, 'helpers.roleResponsibility') ? true : false,
  agreementPrivacyPolicy: get(fields, 'helpers.agreementPrivacyPolicy') ? true : false,
  agreementConditionsAndRequirements: get(fields, 'helpers.agreementRequirements') ? true : false,
  isAgreedToReceivedMarketingMaterialsFromNao: get(fields, 'helpers.marketingFromNao', false),
  countryId: get(fields, 'addressCountryId'),
  assessorWWCExemptionReason: get(fields, 'exemptionReason')
})
